import styled, { css } from 'styled-components';
import { token } from '@zillow/constellation';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { getBreakpointsForHeaderVersion } from 'src/components/ZillowNavbar/utils/getBreakpointsForHeaderVersion';
import { HamburgerProps } from '../types';

export const ZillowNavbarHamburgerInner = styled.span<Pick<HamburgerProps, 'isMobileNavOpen' | 'version'>>`
    ${({ version, isMobileNavOpen }) => css`
        display: block;
        top: 50%;
        &,
        &::before,
        &::after {
            width: 18px;
            height: 2px;
            background-color: ${token('colors.brand')};
            border-radius: 4px;
            position: absolute;
            transition-property: transform;
            transition-duration: 0.15s;
            transition-timing-function: ease;
            display: block;
            ${version === HEADER_VERSIONS.TRANSPARENT_MOBILE_ONLY &&
            !isMobileNavOpen &&
            css`
                @media (max-width: ${getBreakpointsForHeaderVersion(version).MOBILE}px) {
                    background-color: ${token('colors.backgroundWhite')};
                }
            `}
        }

        &::before,
        &::after {
            content: '';
        }
        &::before {
            top: -6px;
            transition: top 0.075s 0.12s ease, opacity 0.075s ease;
        }
        &::after {
            bottom: -6px;
            transition: bottom 0.075s 0.12s ease, transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);
        }
        transition-duration: 0.075s;
        transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
        ${isMobileNavOpen &&
        css`
            transform: rotate(45deg);
            transition-delay: 0.12s;
            transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
            &::before {
                top: 0;
                opacity: 0;
                transition: top 0.075s ease, opacity 0.075s 0.12s ease;
            }
            &::after {
                bottom: 0;
                transform: rotate(-90deg);
                transition: bottom 0.075s ease, transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
            }
        `}
    `};
`;
